module.exports = __webpack_public_path__ + "img/pos-icon-active.61c1aafa.svg";